// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__HkNJD","login":"Input_login__1OO0u","signup":"Input_signup__3HwaU","radio":"Input_radio__17hO1"};